import { render } from "./ShopDetail.vue?vue&type=template&id=257c47ba&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"

import "./ShopDetail.vue?vue&type=style&index=0&id=257c47ba&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257c47ba"]])

export default __exports__